
import { Component, Mixins } from "vue-property-decorator";
import { IObjectsControllable, ILinkedPageObjectSpecifiable, TranscribeTargetKinds } from "../../../../../../documaker/domain/format/objects";
import { ITranscribeBehaviorPropertyEditable, instanceOfITranscribeBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";

@Component
export default class TranscribeBehaviorEditorPropertyEditableMixin extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITranscribeBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITranscribeBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTranscribeBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITranscribeBehaviorPropertyEditable(s) && s.transcribeBehavior().isEditable(), false);
  }

  get transcribeBehavior(): IObjectsControllable<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.transcribeBehavior().getValue(), { targets: [] });
  }

  set transcribeBehavior(value: IObjectsControllable<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.transcribeBehavior().setValue(value));
  }

  get selectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this.readPropertyOrDefault(s => s.getSelectableTranscribeTargets(), []);
  }
}
